<template>
  <div id="delivery-form-list" class="list">
    <div class="delivery-form-list-header list-header">
      <ul>
        <li>{{$_('delivery_form_number')}}</li>
        <li>{{$_('delivery_form_date')}}</li>
        <li>{{$_('carrier_label')}}</li>
        <li>{{$_('number_of_packages')}}</li>
        <li>{{$_('gross_weight_in_kg')}}</li>
        <li>{{$_('delivery_status')}}</li>
        <li>{{$_('tracking')}}</li>
        <li>{{$_('invoice_number')}}</li>
        <li>{{$_('delivery_form')}}</li>
        <li>{{$_('packing_list')}}</li>
      </ul>
    </div>
    <div class="delivery-form-list-body list-body" v-if="items.length > 0">
      <div v-for="(item, index) in items" :key="index">
        <DeliveryFormLine :dataline="item" :index="index" />
      </div>
    </div>
    <div v-else>
      <div class="stock-list-footer no-result">
        <span>{{$_('no_result')}}</span>
      </div>
    </div>
    <div class="pagination-container">
      <Pagination :key="nRender" :nNumeroPage="pagination_info.nNumeroPage" :nNombreElementParPage="pagination_info.nNombreElementParPage" :nNbElementTotal="pagination_info.nNbRecordData" :sTypeElement="$_('delivery_form')" :fn="vLoadDeliveryForm"/>
    </div>
  </div>
</template>

<script>
import deliveryService from '@/modules/facture/services/deliveryService.js';

import Pagination from '@/common/components/widget/Pagination/Pagination'
import DeliveryFormLine from '@/modules/facture/components/DeliveryFormLine';

export default {
  name: 'DeliveryFormList',
  data() {
    return {
      items: Array(),
      pagination_info: {
        nNbRecordData: 0,
        nNombreElementParPage: 20,
        nNumeroPage: 1,
      },
      nRender: 0
    };
  },
  created() {
    this.vLoadDeliveryForm();
  },
  computed: {
    getResearch() {
      return this.$store.getters['facture/get_launch_delivery_research']
    },
  },
  watch: {
    getResearch(val) {
      if(val === true) {
        this.vLoadDeliveryForm();
      }
    }
  },
  methods: {
    vLoadDeliveryForm(nNumeroPage, nNombreElementParPage) {

      let poffset = 0;

      if (nNumeroPage > 0) {
        poffset = nNumeroPage * nNombreElementParPage - nNombreElementParPage
      }

      let fncde = '';
    
      if(this.$route.query.order_id !== undefined && this.$route.query.order_id !== '' ) {
        fncde = this.$route.query.order_id;
      } else {
        fncde = this.$store.getters['facture/get_delivery_fncde'] !== '' ? this.$store.getters['facture/get_delivery_fncde'] : null;
      }

      if(this.$store.getters['facture/get_reset_delivery_list'] === true) {
        this.items = [];
      }

      return deliveryService.getDeliveryForm({
        
        fncde,
        fnbl: this.$store.getters['facture/get_delivery_tnbl'] !== '' ? this.$store.getters['facture/get_delivery_tnbl'] : null,
        fnfact: this.$store.getters['facture/get_delivery_tnfact'] !== '' ? this.$store.getters['facture/get_delivery_tnfact'] : null,
        fdate_bl: this.$store.getters['facture/get_delivery_tdate_bl'] !== '' ? this.$store.getters['facture/get_delivery_tdate_bl'] : null,
        plimit: this.pagination_info.nNombreElementParPage,
        poffset

      }).then(res => {

        this.pagination_info.nNbRecordData = res.data.NB_RECORD

        if( res.data.DS_O !== undefined) {

          res.data.DS_O.OUT.map((obj) => {
            this.items.push(obj)
          })
        }

        this.$store.dispatch('facture/SELECT', {key: 'launch_delivery_research', value: false});
        this.$store.dispatch('facture/SELECT', {key: 'reset_delivery_list', value: false});

        return this.pagination_info;

      }).catch(err => {
        console.error(err)
      });
    }
  },
  components: {
    DeliveryFormLine,
    Pagination
  },
}
</script>

<style scoped>
.delivery-form-list-header ul {
  display: flex;
  align-items: center;
}
.delivery-form-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 10);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.delivery-form-list-header {
  padding: 15px 0px;
}
.no-result {
  text-align: center;
  padding: 20px;
  border: solid 1px #e9e9e9;
  margin-bottom: 20px;
}
.no-result span {
  color: #8B8B8B;
}
.pagination-container {
  margin-top: 20px;
}
</style>